import React from 'react';

interface CourseOptionCardProps {
  title: string;
  description: string;
  iconUrl: string;
  onClick: () => void;
}

const CourseOptionCard: React.FC<CourseOptionCardProps> = ({
  title,
  description,
  iconUrl,
  onClick,
}) => {
  return (
    <div
      className="tw-flex tw-p-5 tw-border-[1px] tw-rounded-lg tw-border-solid tw-border-[#E4E4E7] tw-cursor-pointer"
      onClick={onClick}
    >
      <div
        className="tw-w-10 tw-h-10 tw-mr-4 tw-rounded tw-bg-no-repeat"
        style={{ backgroundImage: `url(${iconUrl})` }}
      />
      <div className="tw-flex tw-flex-col tw-gap-1">
        <h3 className="tw-font-inter">{title}</h3>
        <div className="tw-font-inter">{description}</div>
      </div>
    </div>
  );
};

export default CourseOptionCard;
